import React from "react";
import { ExternalLink } from "lucide-react";

interface ISitePreviewCard {
  title: string;
  url: string | null;
  emptyText: string;
}

export const SitePreviewCard: React.FC<ISitePreviewCard> = ({ title, url, emptyText }) => {
  return (
    <div className="card">
      <div className="flex flex-wrap items-center justify-between mb-2">
        <span className="block text-500 font-medium dark:text-zinc-200">
          {title.toUpperCase()}
        </span>
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 py-1 px-2 text-xs text-indigo-500 dark:text-indigo-300 font-medium bg-indigo-50 dark:bg-indigo-950/50 hover:bg-indigo-100 dark:hover:bg-indigo-900 rounded"
          >
            <ExternalLink size={12} />
            Ouvrir dans un nouvel onglet
          </a>
        )}
      </div>
      {url ? (
        <div className="w-full mt-3 rounded-md overflow-hidden border border-gray-200 dark:border-zinc-800">
          <iframe src={url} title={title} className="w-full h-[1152px]" />
        </div>
      ) : (
        <div className="mt-3 text-sm text-gray-500 dark:text-zinc-400 text-center py-8">
          {emptyText}
        </div>
      )}
    </div>
  );
};
